import {
    useLocation
} from "react-router-dom";


export const useQuery = () => new URLSearchParams(useLocation().search);


export const getQueryObj = () => {
    const search = window.location.hash; //获取url中"?"符后的字串

    const queryObj = {};

    if (search.indexOf("?") != -1) {

        const targetStr = search.split("?")[1];

        const targetArr = targetStr.split("&");

        for(let i = 0; i < targetArr.length; i ++) {
            queryObj[targetArr[i].split("=")[0]] = unescape(targetArr[i].split("=")[1]);
        }
    }
    return queryObj;
};

export const isSubAccount = (names) => {
    if (!names || !Array.isArray(names)) {
        return false;
    }
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const currentUserName = userInfo.user ? userInfo.user.userName : null;
    if (!currentUserName) {
        return false;
    }
    return names.includes(currentUserName);
};
